var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
export var SbRouterService = (function () {
    function SbRouterService(router) {
        this.router = router;
    }
    SbRouterService.prototype.gotoTeam = function () {
        this.router.navigate(['/team']);
    };
    SbRouterService.prototype.subscribeParams = function (activeRoute, next) {
        this.subscription = activeRoute.params.subscribe(next, function (error) { return console.error("Error retreiving route parameters", error); });
    };
    SbRouterService.prototype.unSubscribeParams = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }
    };
    SbRouterService = __decorate([
        Injectable(), 
        __metadata('design:paramtypes', [Router])
    ], SbRouterService);
    return SbRouterService;
}());
//# sourceMappingURL=sb-router.service.js.map